import styled from 'styled-components';

export const Dente = styled.img`
  width: 81%;
  :hover {
    transform: scale(1.05);
  }
`;
